export const EmailValidator = {
    isEmailValid: (emailAddress: string): boolean => {
        const regExp = /\S+@\S+\.\S+/;
        return emailAddress && regExp.test(emailAddress);
    }
};
